import { ScrambleText } from '@/components/ScrambleText';
import { ChevronDown } from 'lucide-react';

const keywords = ['AI', 'DIGITAL', 'IMMERSIVE', 'INSTALLATION', 'NEW MEDIA ART'];

export default function HeroSection() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] flex flex-col items-center justify-center px-6 z-10 pb-20"
      style={{ paddingTop: 'calc(var(--header-height) + 24px)' }}
    >
      <div className="max-w-5xl text-center">
        <ScrambleText
          text="THE RELATIVE"
          className="block font-bold tracking-tighter uppercase text-white font-outfit leading-[0.95] hero-title"
          as="h1"
          duration={900}
          distortOnHover
        />
        <ScrambleText
          text="GALLERY"
          className="block font-bold tracking-tighter uppercase text-white font-outfit leading-[0.95] mt-1 hero-title"
          as="span"
          delay={150}
          duration={900}
          distortOnHover
        />

        <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 mt-8">
          {keywords.map((kw, i) => (
            <ScrambleText
              key={kw}
              text={kw}
              className="text-[10px] sm:text-xs tracking-[0.25em] uppercase font-mono text-[#f6f6f6]"
              as="span"
              delay={600 + i * 100}
              duration={400}
            />
          ))}
        </div>

        <div className="mt-12" data-testid="hero-next-opening">
          <ScrambleText
            text="NEW EVENTS COMING SOON"
            className="block text-xl sm:text-2xl lg:text-3xl font-outfit font-semibold text-[#90E0EF] tracking-tight uppercase"
            as="p"
            delay={1200}
            duration={800}
            distortOnHover
          />
          <p
            className="block text-[11px] sm:text-xs tracking-[0.3em] uppercase font-mono text-[#f6f6f6] mt-4"
            data-testid="hero-gallery-open"
          >
            Stay close — something new is on the way
          </p>
        </div>
      </div>

      <div className="absolute bottom-6 flex flex-col items-center gap-3 animate-pulse-fade">
        <span className="text-[10px] font-mono tracking-[0.3em] text-[#f6f6f6] uppercase">
          Scroll to explore
        </span>
        <ChevronDown className="w-4 h-4 text-[#f6f6f6]" />
      </div>
    </section>
  );
}
